import { CONTRACT_TYPE_ID } from '../constants/ObjectTypeIds';
export const EDIT_DISABLED_PROPERTIES = new Set(['hs_hubspot_billing_enabled', 'hs_currency_code', 'hs_discount_code', 'hs_start_date', 'hs_end_date', 'hs_status', 'hs_allowed_payment_methods', 'hs_payment_enabled', 'hs_payment_method', 'hs_automated_taxes_enabled']);
export function isReadOnlyContractProperty({
  objectTypeId,
  propertyName,
  hubspotDefined,
  hs_hubspot_billing_enabled
}) {
  if (objectTypeId !== CONTRACT_TYPE_ID || !hubspotDefined) {
    // if this is not a contract or it's a custom property everything is editable
    return false;
  }
  if (!propertyName) {
    // default to editable if we cannot determine the property name
    return false;
  }
  if ('hs_hubspot_billing_enabled' === propertyName) {
    // hs_hubspot_billing_enabled is never directly editable
    return true;
  }
  if (hs_hubspot_billing_enabled !== 'true') {
    // if the contract isn't billing enabled everything is editable (it's unmanaged by HS)
    return false;
  }
  return EDIT_DISABLED_PROPERTIES.has(propertyName);
}